import React from 'react';
import { SpaceBetween, Button } from '@amzn/awsui-components-console';
import { getPhoneToolImageURL } from 'src/pages/entitySearch/entitySearchConstants';
import Avatar from './avatar/avatar';
import PropTypes from 'prop-types';

type AvatarSize = 'small' | 'medium' | 'large';

interface UserIconProps {
	user: string;
	size?: AvatarSize;
	iconOnly?: boolean;
}

export const UserIcon = ({user, size = 'small', iconOnly = false}: UserIconProps) => {
	
	if (iconOnly) {
		return user ? (
			<Avatar src={getPhoneToolImageURL(user)} alt={user} size={size}/>
		) : null;
	}
		
	return <SpaceBetween direction='horizontal' size='xs'>
	 {(user) && (
			<>
				<Avatar src={getPhoneToolImageURL(user)} alt={user} size={size}/>
				<Button variant="inline-link" href={`https://phonetool.amazon.com/users/${user}`} target="_blank">{user}</Button>
			</>
		)}
	</SpaceBetween>
	;
};

UserIcon.propTypes = { 
	user: PropTypes.string.isRequired,
	size: PropTypes.oneOf(['small', 'medium', 'large']),
	iconOnly: PropTypes.bool,
};